//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import eventBus from "../../services/eventBus";
import AddYoutubeModal from "./AddMediaModals/AddYoutubeModal";
import AddVeomoModal from "./AddMediaModals/AddVeomoModal";
import AddWebsiteModal from "./AddMediaModals/AddWebsiteModal.vue";
import AddPlugModal from "./AddMediaModals/AddPlugModal.vue";
import AddInstaModalVue from "./AddMediaModals/AddInstaModal.vue";
import { mapGetters } from "vuex";
import AddCountdownModal from "./AddMediaModals/AddCountdownModal.vue";

export default {
  computed: {
    ...mapGetters(["getFbToken", "getUser"]),
  },
  name: "add-media-button",
  props: [],

  data() {
    return {
      file: "",
      message: "",
    };
  },
  methods: {
    featureAvailable(id) {
      const feature = this.getUser.features.find(
        (feature) => feature.featureId === id
      );
      if (feature) {
        return feature.enabled;
      } else {
        return false;
      }
    },
    onSelect() {
      const file = this.$refs.file.files[0];
      this.file = file;
    },
    chooseFiles: function() {
      eventBus.$emit("chooseFilesForUpload");
    },
    addYoutubeVideo() {
      this.$q.dialog({
        component: AddYoutubeModal,
        root: this,
      });
    },
    addVeomoDashboard() {
      this.$q.dialog({
        component: AddVeomoModal,
        root: this,
      });
    },
    addWebsite() {
      this.$q.dialog({
        component: AddWebsiteModal,
        root: this,
      });
    },
    addCountdown() {
      this.$q.dialog({
        component: AddCountdownModal,
        root: this,
      });
    },
    addPlug() {
      this.$q.dialog({
        component: AddPlugModal,
        root: this,
      });
    },
    addInstagramFeed() {
      this.$q.dialog({
        component: AddInstaModalVue,
        root: this,
      });
    },
  },
};
